import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDSnackbar from "components/MDSnackbar";
import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  Box,
  Typography,
  Fade,
} from "@mui/material";
import usersTableData from "layouts/tables/data/usersTableData";

function Tables() {
  const {
    columns,
    rows,
    activeCount,
    pendingCount,
    blockedCount,
    isModalOpen,
    handleCloseModal,
    handleSaveChanges,
    editedUser,
    setEditedUser,
    notification,
    handleCloseNotification,
  } = usersTableData();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3} marginBottom={5}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="people"
                title="All Users"
                count={activeCount + pendingCount + blockedCount}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="timer"
                title="Pending Users"
                count={pendingCount}
                color="warning"
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="done"
                title="Active Users"
                count={activeCount}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="block"
                title="Blocked Users"
                count={blockedCount}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Users Table
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={false}
                  showTotalEntries
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog
        open={isModalOpen}
        onClose={handleCloseModal}
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 500 }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
          Update User Information
        </DialogTitle>

        <DialogContent>
          {editedUser && (
            <Box display="flex" flexDirection="column" gap={2}>
              {/* User State Selection */}
              <Box>
                <Typography variant="subtitle2" fontWeight="medium" mb={1}>
                  User State
                </Typography>
                <Select
                  name="state"
                  value={editedUser?.state || ""}
                  onChange={(e) => setEditedUser((prev) => ({ ...prev, state: e.target.value }))}
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginTop: "1px",
                    padding: "11px",
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0, 0, 0, 0.3)" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1e88e5" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1e88e5" },
                  }}

                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Blocked">Blocked</MenuItem>
                </Select>
              </Box>

              {/* User Role Selection */}
              <Box>
                <Typography variant="subtitle2" fontWeight="medium" mb={1}>
                  User Role
                </Typography>
                <Select
                  name="role"
                  value={editedUser?.role || ""}
                  onChange={(e) => setEditedUser((prev) => ({ ...prev, role: e.target.value }))}
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginTop: "1px",
                    padding: "11px",
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0, 0, 0, 0.3)" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1e88e5" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1e88e5" },
                  }}

                >
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="Customer">Customer</MenuItem>
                </Select>
              </Box>
            </Box>
          )}
        </DialogContent>
                <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">
                    Cancel
                  </Button>
          <Button onClick={handleSaveChanges} color="primary">
                    Save
                  </Button>
                </DialogActions>
        
      </Dialog>
      ;{/* Notification Snackbar */}
      <MDSnackbar
        color={notification.severity}
        icon={notification.severity === "success" ? "check" : "error"}
        title={notification.severity === "success" ? "Success" : "Error"}
        content={notification.message}
        open={notification.open}
        onClose={handleCloseNotification}
        close={handleCloseNotification}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default Tables;
